import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PageContentContainer from 'components/PageContentContainer';
import axios from 'axios';

const ReportAnIssue = ({ location }) => {
  const [values, setValues] = useState({
    Email: '',
    Description: '',
    Page: location?.state?.pathname ? `https://ziki.fm${location?.state?.pathname || ''}` : '',
  });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (event) => {
    setValues({ ...values, [event.target.id]: event.target.value });
  };

  const renderField = (label, type, params, required = true) => {
    return (
      <TextField
        key={label}
        id={label}
        label={label}
        type={type}
        {...params}
        value={values[label]}
        margin="normal"
        fullWidth
        onChange={handleChange}
        variant="outlined"
        required={required}
      />
    );
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setSending(true);
      setStatus('');
      const response = await axios.post('/api/contact', values);
      if (response.status === 200 && response.data === 'success') {
        setStatus('Message sent. We will get back to you shortly');
        setSending(false);
        setValues({ email: '', message: '' });
      } else {
        setStatus('There was an error. Please try again or email directly at contact@ziki.fm');
        setSending(false);
      }
    } catch (e) {
      setStatus('There was an error. Please try again or email directly at contact@ziki.fm');
      setSending(false);
    }
  };

  return (
    <PageContentContainer
      heading="Report an issue"
      breadcrumb="support"
      meta={{
        description: 'Spotted an issue or some wrong information on ZIKI.FM? Report it here',
      }}
    >
      <Typography>Please provide information about the issue you have experienced</Typography>
      {status.startsWith('Message sent') ? null : (
        <form onSubmit={handleSubmit}>
          {renderField(
            'Email',
            'email',
            {
              helperText:
                'If you would like updates on the issue reported, please provide your email',
            },
            false
          )}
          {renderField('Page', 'text', { helperText: 'The page where the issue occured' }, false)}
          {renderField('Description', 'text', {
            multiline: true,
            rows: 6,
          })}
          {sending ? (
            <Button variant="contained" type="submit" disabled>
              Sending...
            </Button>
          ) : (
            <Button variant="contained" type="submit">
              Send
            </Button>
          )}
        </form>
      )}
      <Typography component="div">
        <p>{status}</p>
      </Typography>
    </PageContentContainer>
  );
};

export default ReportAnIssue;
